// extracted by mini-css-extract-plugin
export default {"modal":"oda-z","modalContent":"pda-z","footer":"qda-z","cancelBtn":"rda-z","disabled":"sda-z","formWrapper":"tda-z","fade":"uda-z","fade-in":"vda-z","iframe":"wda-z"};